import type { ConnectedUser } from "../Model/ConnectedUser";
import type { ResponseApi } from "../Model/ResponseApi";
import { JsonFetch } from "./FetchHelper";
import { OnTokenLogin } from "./events";

export class BasketHelper {
    private static _instance: BasketHelper;

    public static get Instance(): BasketHelper {
        if (this._instance == null)
            this._instance = new BasketHelper();

        return this._instance;
    }

    constructor() {
        OnTokenLogin.Clear("basket");
        OnTokenLogin.Bind((cu: ConnectedUser) => {
            this.GetBasketInformation(cu);
        });
    }

    private GetBasketInformation = (cu: ConnectedUser) => {
        const filter = {
            FkClient: cu.FkClient,
            IncludeCommandeItems: true,
            AsNoTracking: true
        }
        JsonFetch.FetchJson.Post<ResponseApi<any>>("/panier/", filter)
            .then((response) => {
                if (response.Status != 200)
                    return;

                if (response.Data == null || response.Data.length == 0)
                    return;

                const p = response.Data[0];

                if (p.CommandeItems == null)
                    return;

                const a = $("[circ-id='basket-badge']")
                a.kendoBadge({align: 'top end', position: 'inside', themeColor: 'primary', size: 'small'})
                a.text(p.CommandeItems.length);


            })
    }
}
